import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["container", "button"]
  static values = { open: Boolean }

  toggle() {
    this.openValue = !this.openValue
  }

  open() {
    this.openValue = true
  }

  close() {
    this.openValue = false
  }

  navigate(event) {
    if (event.target.closest("a")) this.close()
  }

  clickOutside(event) {
    if (!this.openValue) return
    if (this.containerTarget.contains(event.target) || this.buttonTarget.contains(event.target)) return

    this.close()
  }

  openValueChanged(open) {
    if (this.hasButtonTarget) this.buttonTarget.setAttribute("aria-expanded", open)
  }
}
